// implemented Input Types in CustomFieldComponent

export enum InputType {
	AlignRight = 'AlignRight',
	AlignCenter = 'AlignCenter',
	CustomFieldAvailableInputTypes = 'CustomFieldAvailableInputTypes',
	Date = 'Date',
	Document = 'Document',
	DocumentOrImage = 'DocumentOrImage',
	Dq = 'Dq',
	DqLabel = 'DqLabel',
	DqMulti = 'DqMulti',
	DqRadio = 'DqRadio',
	Duration = 'Duration',
	DurationAsTimeTo = 'DurationAsTimeTo',
	EntryDescriptionMulti = 'EntryDescriptionMulti',
	File = 'File',
	FileLink = 'FileLink',
	GPS = 'GPS',
	HexColor = 'HexColor',
	Id = 'Id',
	Image = 'Image',
	Integer = 'Integer',
	JaNeinCheckbox = 'JaNeinCheckbox',
	JaNeinNull = 'JaNeinNull',
	JaNeinRadio = 'JaNeinRadio',
	JaNeinToggle = 'JaNeinToggle',
	KBerschl = 'KBerschl',
	Key = 'Key',
	Kost = 'Kost',
	Kostkey = 'Kostkey',
	Label = 'Label',
	LinkButton = 'LinkButton',
	Number = 'Number',
	Password = 'Password',
	Person = 'Person',
	Photo = 'Photo',
	Raw = 'Raw',
	Signature = 'Signature',
	SisDate = 'SisDate',
	String = 'String',
	Textarea = 'Textarea',
	Time = 'Time',
	Uri = 'Uri',
	Verbose = 'Verbose',
	Video = 'Video',
}

export const InputTypeDoc: Record<InputType, string> = {
	[InputType.AlignRight]: 'rechtsbündig',
	[InputType.AlignCenter]: 'zentriert',
	[InputType.CustomFieldAvailableInputTypes]: 'Verwendbare Werte in CFDef.input (inkl. Dokumentation der notwendigen Parameter zur Verwendung)',
	[InputType.Date]: 'Datepicker',
	[InputType.Document]: 'Dokument mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.DocumentOrImage]: 'Dokument oder Bild mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.Dq]: 'Dropdown Eingabefeld (Select)',
	[InputType.DqLabel]: 'Dropdown, das den "value" der Datenquelle ausblendet. Eine direkte, freie Eingabe eines Wertes ist in diesem Feld nicht möglich (Dafür wird "Dq" benötigt)',
	[InputType.DqMulti]: 'Dropdown Eingabefeld (MultiSelect). Mehrere Werte werden in einen String serialisiert. Trennzeichen wird mit CFAttrKey="separator" parametriert. cfdef.type = C verwenden!',
	[InputType.DqRadio]: 'Datenquelleninhalt wird durch Radio-Buttons dargestellt',
	[InputType.Duration]: 'siehe "String" (cfdef.type = H verwenden)',
	[InputType.DurationAsTimeTo]: 'Zeitspanne (zsp) umformen in Biszeit (für von/bis Buchungen wie im onClient). Benötigt CFAttrKey="TimeFromAttr"',
	[InputType.EntryDescriptionMulti]: 'MultiInput für Buchung/Persurl-Typen. Mehrere Werte (typemap2.id) werden in einen String serialisiert. Trennzeichen wird mit CFAttrKey="separator" parametriert. cfdef.type = C verwenden!',
	[InputType.File]: 'Datei mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.FileLink]: 'Anzeige der Datei mit der ID im PERSISTIERTEN Modell oder cfdef.defaultvalue',
	[InputType.GPS]: 'GPS Input. Generiert Daten in cf_gps: lat,lon!',
	[InputType.HexColor]: "Transformiert die Eingabe und färbt die Zelle nach der Eingabe.",
	[InputType.Id]: 'Für ganzzahlige IDs; rechtsbündig.',
	[InputType.Image]: 'Bilder mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.Integer]: '(alias) Number Input',
	[InputType.JaNeinCheckbox]: 'Checkbox für J/N Feld (benötigt default!)',
	[InputType.JaNeinNull]: 'Tri-PersInfState Select für z.B. persurl.offen_kz',
	[InputType.JaNeinRadio]: 'Radio Button Group die ein nachträgliches Löschen nicht mehr ermöglicht',
	[InputType.JaNeinToggle]: 'Toggle Switch für J/N Feld (benötigt default!)',
	[InputType.Key]: '-> String',
	[InputType.Kost]: 'Kostenstelle auswählen. Nur in Apps mit KostModule verwendbar (z.B. sheet). KBerschl angewendet.',
	[InputType.KBerschl]: 'Kostenstelle auswählen. Nur in Apps mit KostModule verwendbar (z.B. sheet). KBerschl angewendet.',
	[InputType.Kostkey]: 'Kostenstelle auswählen. Wie cfDef.input=Kost, nur kann der Kostkey direkt und exakt eingegeben werden. Nur in Apps mit KostModule verwendbar (z.B. sheet). KBerschl angewendet.',
	[InputType.Label]: 'Nur Label wird angezeigt. Ist eine Datenqulle definiert, dann werden alle label-Werte angezeigt. (Kein cf.-dstField verwenden!)',
	[InputType.LinkButton]: 'Button mit href, der aus der Datenquelle kommt. CFDef Implementierung des DqButton, die allerdings die Parametrierung aus dem CFDef übernimmt. cfDef.dstField = "_dummy" ! ',
	[InputType.Number]: 'Dezimalzahlen unter berücksichtiung Komma oder Punkt und Rundung',
	[InputType.Password]: 'Passwort Eingabefeld; Werte durch Punkte ersetzt.',
	[InputType.Person]: 'Personen auswählen. Nur in Apps, in denen die Personen verwendet werden (i.e. ja: timeline; nein: notification) Es werden die Personen angezeigt, für die der Benutzer berechtigt ist.',
	[InputType.Photo]: 'Bilder mittels Drag & Drop hinzufügen. Benötigt type="B"',
	[InputType.Raw]: "Ohne Custom-Field Regeln! Zeigt 'null' Werte als null an.",
	[InputType.Signature]: 'Unterschrift erfassen. Benötigt type="B"',
	[InputType.SisDate]: '(deprecated!) -> Date ',
	[InputType.String]: 'Standard-Eingabefeld',
	[InputType.Textarea]: 'Standard-Eingabefeld, Zeilenvorschub (new line) erlaubt',
	[InputType.Time]: 'Standard-Eingabefeld',
	[InputType.Uri]: 'Wert wird in textueller Darstellung als Link angezeigt',
	[InputType.Verbose]: 'Custom-Field Regeln deaktiviert! Formatiert die eingegebenen Werte nach der Eingabe so, dass unsichtbare Zeichen sichtbar sind.',
	[InputType.Video]: 'Video mittels Drag & Drop hinzufügen. Benötigt type="B"',
} as const
